


















































































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import * as avidia from "@/shared/avidiaUrls";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";

@Component({
  components: {}
})
export default class AvidiaForms extends Vue {
  AvidiaUrls = avidia;

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
